import React from 'react';
import { CheckIcon, TrophyIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const notThis = ['No es una colección de ideas sueltas.', 'No es un simple ebook.', 'No es material desordenado que tenés que acomodar desde cero.'];
const isThis = ['Es un megapack digital organizado por tomos.', 'Listo para consultar, adaptar y usar todo el año escolar.', 'Pensado para entrar a la sala con más claridad y menos estrés.'];
export function SystemIntro() {
  return <section className="w-full bg-forest-50 px-5 py-16 sm:py-20" aria-labelledby="system-title" data-id="element-241" data-mp="1firfxxrrfxmb">
      <div className="mx-auto max-w-3xl" data-id="element-242" data-mp="1khunppz4khxz">
        <div className="text-center" data-id="element-243" data-mp="1kgt0yo8qy70f">
          <TrophyIcon className="mx-auto h-9 w-9 text-gold-500" aria-hidden="true" data-id="element-244" data-mp="1phh1q1ms227u" />
        </div>
        <div className="mt-4" data-id="element-245" data-mp="2vxj94cwqd8wo">
          <SectionHeading id="system-title" title={<>
                El sistema digital más completo para maestras jardineras de{' '}
                <span className="mark-lime" data-id="element-247" data-mp="30uszbury1olk">Nivel Inicial</span>
              </>} subtitle={<>
                <strong className="text-forest-800" data-id="element-248" data-mp="15huh4xecjvzl">MegaPack Seño Jardín</strong> · 6 tomos + 5 bonos
                especiales gratis. Todo listo para consultar, adaptar y usar durante el año escolar.
              </>} data-id="element-246" data-mp="2vyc7oqljcs3q" />
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-249" data-mp="riuqjk79x70s">
          <div className="rounded-2xl border-2 border-forest-100 bg-white p-5 shadow-card" data-id="element-250" data-mp="ricrkft88ep6">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-forest-900/45" data-id="element-251" data-mp="mlcirx4zsxud">
              Lo que no es
            </p>
            <ul className="mt-3 space-y-2.5" data-id="element-252" data-mp="drhessflxdgb">
              {notThis.map(item => <li key={item} className="flex items-start gap-2 text-[13px] text-forest-900/75" data-id="element-253" data-mp="drpoyckci4nt">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-blush-500" aria-hidden="true" data-id="element-254" data-mp="8u7ozbob2zry" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border-2 border-lime-200 bg-lime-100 p-5 shadow-card" data-id="element-255" data-mp="3v0w7qjymru3m">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-forest-700" data-id="element-256" data-mp="3laxrtffe6une">
              Lo que sí es
            </p>
            <ul className="mt-3 space-y-2.5" data-id="element-257" data-mp="3q8pftycx1wmb">
              {isThis.map(item => <li key={item} className="flex items-start gap-2 text-[13px] font-semibold text-forest-800" data-id="element-258" data-mp="3ccly34j8bgqq">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-lime-600" aria-hidden="true" data-id="element-259" data-mp="3gd5xyfv6sygk" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}